__turbopack_context__.v({
  "component__address": "index-module__HqzmPG__component__address",
  "component__addressWrapper": "index-module__HqzmPG__component__addressWrapper",
  "component__buttonWrapper": "index-module__HqzmPG__component__buttonWrapper",
  "component__close": "index-module__HqzmPG__component__close",
  "component__contentWrapper": "index-module__HqzmPG__component__contentWrapper",
  "component__headerBadge": "index-module__HqzmPG__component__headerBadge",
  "component__headerIcon": "index-module__HqzmPG__component__headerIcon",
  "component__heading": "index-module__HqzmPG__component__heading",
  "component__icon": "index-module__HqzmPG__component__icon",
  "component__modalContainer": "index-module__HqzmPG__component__modalContainer",
  "component__subheading": "index-module__HqzmPG__component__subheading",
});
